import * as React from 'react';
import autobind from 'autobind-decorator';

import { ProductListDataService } from 'src/app/products/products/list/product-list.data';
import { ProductEditorView } from './product-editor.view';
import { observer } from 'mobx-react';

interface ProductEditorControllerProps {
	value: number | number[] | null;
	mode: ControlMode;
	multi?: boolean;
	onChanged: (value: any) => void;
	setBusy(isBusy: boolean);
	label?: string;
	productType?: number;
	categoryId?: number;
	serviceId?: number;
	regionId?: number;
	placeId?: number;
	fromPlaceId?: number;
	toPlaceId?: number;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	baseProductDisable?: boolean;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
}
@observer
export class ProductEditorController extends React.Component<ProductEditorControllerProps, any> {
	protected productDataService: ProductListDataService;

	constructor(props) {
		super(props);
		this.productDataService = ProductListDataService.make();
	}

	@autobind
	protected productQuery(q?: string): Promise<QueryResult<ProductSummary>> {
		return new Promise<QueryResult<ProductSummary>>((resolve, reject) => {
			this.props.setBusy(true);
			this.productDataService.addFilter('isDeleted', 'eq', false);
			if (this.props.productType != null) {
				this.productDataService.addFilter('productType', 'eq', this.props.productType);
			}
			else if (this.props.productType == null && this.productDataService.hasFilter('productType')) {
				this.productDataService.removeFilter('productType');
			}
			if (this.props.categoryId != null) {
				this.productDataService.addFilter('categoryId', 'eq', this.props.categoryId);
			}
			else if (this.props.categoryId == null && this.productDataService.hasFilter('categoryId')) {
				this.productDataService.removeFilter('categoryId');
			}
			if (this.props.serviceId != null) {
				this.productDataService.params["serviceId"] = this.props.serviceId;
			}
			else if (this.props.serviceId == null && this.productDataService.params["serviceId"]) {
				delete this.productDataService.params["serviceId"];
			}
			if (this.props.regionId != null) {
				this.productDataService.addFilter('regionId', 'eq', this.props.regionId);
			}
			else if (this.props.regionId == null && this.productDataService.hasFilter('regionId')) {
				this.productDataService.removeFilter('regionId');
			}
			if (this.props.placeId != null) {
				this.productDataService.addFilter('placeId', 'eq', this.props.placeId);
			}
			else if (this.props.placeId == null && this.productDataService.hasFilter('placeId')) {
				this.productDataService.removeFilter('placeId');
			}
			if (this.props.fromPlaceId != null) {
				if (this.props.productType == 2) {
					this.productDataService.params["fromCarPlaceId"] = this.props.fromPlaceId;

				}
				else if (this.props.productType == 3) {
					this.productDataService.params["fromTransferPlaceId"] = this.props.fromPlaceId;

				}
			}
			else if (this.props.fromPlaceId == null) {
				if (this.props.productType == 2 && this.productDataService.params["fromCarPlaceId"]) {
					delete this.productDataService.params["fromCarPlaceId"];
				}
				else if (this.props.productType == 3 && this.productDataService.params["fromTransferPlaceId"]) {
					delete this.productDataService.params["fromTransferPlaceId"];
				}

			}
			if (this.props.toPlaceId != null) {
				if (this.props.productType == 2) {

					this.productDataService.params["toCarPlaceId"] = this.props.toPlaceId;
				}
				else if (this.props.productType == 3) {

					this.productDataService.params["toTransferPlaceId"] = this.props.toPlaceId;
				}
			}
			else if (this.props.toPlaceId == null) {
				if (this.props.productType == 2 && this.productDataService.params["toCarPlaceId"]) {
					delete this.productDataService.params["toCarPlaceId"];
				}
				else if (this.props.productType == 3 && this.productDataService.params["toTransferPlaceId"]) {
					delete this.productDataService.params["toTransferPlaceId"];
				}

			}
			this.productDataService.addSorting('id', 'asc', true);
			this.productDataService.pageSize = 50;
			this.productDataService.searchKeywords = q;
			this.productDataService.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({
						items: items,
						totalCount: this.productDataService.count
					});
				});
		});
	}

	render() {
		return (
			<ProductEditorView
				productRequest={{ query: this.productQuery, dataSet: this.productDataService }}
				label={this.props.label}
				multi={this.props.multi}
				onChanged={this.props.onChanged}
				value={this.props.value}
				mode={this.props.mode}
				required={this.props.required}
				productType={this.props.productType}
				categoryId={this.props.categoryId}
				regionId={this.props.regionId}
				placeId={this.props.placeId}
				fromPlaceId={this.props.fromPlaceId}
				toPlaceId={this.props.toPlaceId}
				serviceId={this.props.serviceId}
				onGetErrorMessage={this.props.onGetErrorMessage}
				baseProductDisable={this.props.baseProductDisable}
				afterLoad={this.props.afterLoad}
			>
				{this.props.children}
			</ProductEditorView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/products/parts/product-editor.controller.tsx